<template>
    <div>
        <b-card>
          <h3>Available Stock</h3>
          <br/>
          <div class="accordion" role="tablist">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-1 variant="info">Devices</b-button>
          </b-card-header>
          <b-collapse id="accordion-1" visible accordion="StockAccordian" role="tabpanel">
        <b-card-body>
          Show the Devices Here for selection
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-2 variant="info">Routers</b-button>
      </b-card-header>
      <b-collapse id="accordion-2" accordion="StockAccordian" role="tabpanel">
        <b-card-body>
          Show the Routers Here for selection
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-3 variant="info">Other Hardware</b-button>
      </b-card-header>
      <b-collapse id="accordion-3" accordion="StockAccordian" role="tabpanel">
        <b-card-body>
          Show other stuff here that they could select
          We can hide this tab to begin with if there isn't anything.
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>

        </b-card>
    </div>
</template>

<script>
    export default {
      data() {
      return {
        stepComplete: false,
        ChosenArray: {},
      }
    },
    computed: {},
    components: {},
    methods:{},

    }
</script>

<style>

</style>